<template>
  <div class="container">
    <h1 class="glitch">LimitYangのblog</h1>
  </div>
</template>

<script>
export default {
  name: 'BugFont'
}
</script>

<style scoped>
@import './css/style.css';
.container {
  /* height: 100vh; */
  /* background: #333; */
  /* display: grid; */
  /* place-items: center; */
  font-size: 10px;
}
.container .glitch {
  color: #fff;
  font-size: 10em;
  position: relative;
  font-family: 'Helvetica Neue', Helvetica, 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei',
    '微软雅黑', Arial, sans-serif;
  font-weight: 400;
}
.container .glitch::before,
.container .glitch::after {
  content: 'LimitYangのlog';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  overflow: hidden;
  background-color: rgb(0, 37, 60, 0.9);
  color: #fff;
}
.container .glitch::before {
  left: 8px;
  text-shadow: 2px 0 #00ffea;
  animation: glitch 3s infinite linear;
}
.container .glitch::after {
  left: 8px;
  text-shadow: -2px 0 #fe3a7f;
  animation: glitch 2s infinite linear;
}
</style>
